import { render } from "./Breadcrumb.vue?vue&type=template&id=23802e8a"
import script from "./Breadcrumb.vue?vue&type=script&lang=js"
export * from "./Breadcrumb.vue?vue&type=script&lang=js"
script.render = render

export default script